import "./styles.css";
import DiceBox from "@3d-dice/dice-box-threejs";
const tmi = require("tmi.js");

const DICE_BOXES = [];
const MAX_DICE_BOXES = 5;
let currentDiceBoxIndex = 0;

for(let i = 0; i < MAX_DICE_BOXES; i++) {
    let diceBox = new DiceBox(`#dicebox${i}`, {
        gravity_multiplier: 600,
        baseScale: 100,
        strength: 2
    });
    diceBox.initialize();
    DICE_BOXES.push(diceBox);
}

const client = new tmi.Client({
    channels: ["sweetholyheck"],
    // options: {
    //     debug: true
    // }
});

client.connect();

client.on("usernotice", (msgid, channel, tags, message) => {
    if(msgid === "announcement" && tags["display-name"].toLowerCase() === "streamelements") {
        let messageMatch = message.match(/^.*? lance le dé et tombe sur un\.\.\. (\d+)!$/);
        if(messageMatch) {
            let diceBox = DICE_BOXES[currentDiceBoxIndex];
            currentDiceBoxIndex = (currentDiceBoxIndex + 1) % MAX_DICE_BOXES;

            diceBox.roll(`1d20@${messageMatch[1]}`)
                .then(() => {
                    setTimeout(() => {
                        diceBox.clearDice();
                    }, 5000);
                });
        }
    }
});